exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* .switch-label {\n  margin-bottom: 3px !important\n} */\n", ""]);

// exports
